import $ from 'jquery'
import configurations from '../../../helpers/misc/configurations'
import {
	t,
} from '../../../helpers/global'
import { fromJS } from 'immutable'

import snakeCase from 'voca/snake_case'
export const requiredCase = value => value ? undefined : ` is required`

const validate = (values, props) => {
	const job = props.publicJobDetail.job || {}
	const translationsJob = props.publicJobDetail.translation || {}
	const translations = fromJS(translationsJob)
	let document_list = []
	if (job.document_list) {
		document_list = JSON.parse(job.document_list)
	}
	const emailRequired = job.email_required
	const errors = {}

	document_list.map((value) => {
		let valuestring = value.type.replace(/\./g, ' ')

		if (value.option_value == 2) {
			if (!values[valuestring] || values[valuestring].trim() === '') {
				errors[valuestring] = `${value.type} REQUIRED_LANDING_PAGE`
			}
		}

	})

	if (!values.fullname || $.trim(values.fullname) === '') {
		errors.fullname = `ERROR_EMPTY_FULL_NAME`
	}
	if (emailRequired) {
		if (!values.email || $.trim(values.email) === '') {
			errors.email = `ERROR_EMPTY_EMAIL`
		}

		if (!values.email2 || $.trim(values.email2) === '') {
			errors.email2 = `ERROR_EMPTY_CONFIRMATION_EMAIL`
		}

		if (values.email && !configurations.emailRegex.test(values.email.toLowerCase())) {
			errors.email = 'ERROR_INVALID_EMAIL'
		}

		if (values.email2 && !configurations.emailRegex.test(values.email2.toLowerCase())) {
			errors.email2 = 'ERROR_INVALID_EMAIL'
		}

		if (values.email && values.email2 && values.email.toLowerCase() !== values.email2.toLowerCase()) {
			errors.email2 = 'ERROR_NOT_MATCH_EMAIL'
		}
	}
	if (!values.phone || $.trim(values.phone) === '') {
		errors.phone = `ERROR_EMPTY_PHONE`
	}

	if (values.phone && !configurations.phoneRegex.test(values.phone)) {
		errors.phone = 'ERROR_INVALID_PHONE'
	}

	if (!values.preferred_name || $.trim(values.preferred_name) === '') {
		errors.preferred_name = `ERROR_EMPTY_PREFERRED_NAME`
	}

	const additionalFields = props.publicJobDetail.additionalField || []
	additionalFields.map((additionalField, index) => {
		let inputName = `${snakeCase(additionalField.label)}-${additionalField.id}`
		if (additionalField.is_mandatory == 1) {
			if (!values[inputName]) {
				if (additionalField.input_type == 7) {
					errors[inputName] = `${additionalField.label} ${t(translations, 'ERROR_IS_REQUIRED')}`
				} else {
					errors[inputName] = `${additionalField.label} Field ${t(translations, 'ERROR_BLANK')}`
				}
			} else {
				if (additionalField.input_type == 1) {
					let countText = 0;
					let word = values[inputName]
					if (word.trim().length == 0) {
						countText = 0;
					} else {
						countText = values[inputName] == "" ? 0 : values[inputName].match(/\S+/g).length;
					}

					if (additionalField.minWords) {
						if (countText < additionalField.minWords) {
							errors[inputName] = `${additionalField.label} Field ${t(translations, 'LABEL_AT_LEAST_HAVE')} ${additionalField.minWords} ${t(translations, 'LABEL_WORDS')}`
						}
					}
					if (additionalField.maxWords) {
						if (countText > additionalField.maxWords) {
							errors[inputName] = `${additionalField.label} Field ${t(translations, 'LABEL_AT_LEAST_HAVE')} ${additionalField.minWords} ${t(translations, 'LABEL_WORDS')}`
						}
					}
				} else if (additionalField.input_type == 3) {
					if (additionalField.min) {
						if (parseInt(values[inputName]) < parseInt(additionalField.min)) {
							errors[inputName] = `${additionalField.label} Field ${t(translations, 'LABEL_LESS_THAN')} ${additionalField.min}`
						}
					}
					if (additionalField.max) {
						if (parseInt(values[inputName]) > parseInt(additionalField.max)) {
							errors[inputName] = `${additionalField.label} Field ${t(translations, 'LABEL_MORE_THAN')} ${additionalField.max}`
						}
					}
				} else if (additionalField.input_type == 7) {
					if (additionalField.accept != '*.*') {
						let value = values[inputName]
						let type = value.name.split('.').pop()
						let acceptedFiles = additionalField.accept.split(',');
						if (!acceptedFiles.includes(`.${type}`)) {
							errors[inputName] = `${t(translations, 'NOT_SUPPORTED_FILE_LANDING_PAGE')}`
						}
					}

				}
			}
		}

	})

	// Validate employment history company_name
	if (values.employment_history && Array.isArray(values.employment_history)) {
		const employmentHistoryErrors = []
		values.employment_history.forEach((employment, index) => {
			const employmentErrors = {}
			if (!employment.company_name || $.trim(employment.company_name) === '') {
				employmentErrors.company_name = 'ERROR_EMPTY_COMPANY_NAME'
			}
			if (Object.keys(employmentErrors).length > 0) {
				employmentHistoryErrors[index] = employmentErrors
			}
		})
		if (employmentHistoryErrors.length > 0) {
			errors.employment_history = employmentHistoryErrors
		}
	}

	// console.log(errors,'erros')
	return errors
}

export default validate
